import React, {
  createContext,
  useState,
  ReactNode,
  Dispatch,
  SetStateAction,
  useRef,
  useContext,
} from 'react';

interface SidebarContextType {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
  content: JSX.Element | null;
  setContent: Dispatch<SetStateAction<JSX.Element | null>>;
}

const SidebarContext = createContext<SidebarContextType>({
  isOpen: false,
  setIsOpen: () => {},
  title: '',
  setTitle: () => {},
  content: null,
  setContent: () => {},
});

export const useSidebar = () => useContext(SidebarContext);

export const SidebarProvider = ({ children }: { children: ReactNode }) => {
  const [title, setTitle] = useState<string>('');
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [content, setContent] = useState<JSX.Element | null>(null);
  const boxRef = useRef<HTMLDivElement | null>(null);

  return (
    <SidebarContext.Provider
      value={{
        isOpen,
        setIsOpen,
        content,
        setContent,
        title,
        setTitle,
      }}
    >
      {children}
    </SidebarContext.Provider>
  );
};
